import { createBrowserHistory } from 'history';

const browserHistory = createBrowserHistory({ window });

export default browserHistory;
